// extracted by mini-css-extract-plugin
export default {"Switch":"styles_Switch__8D+n+","option":"styles_option__iyz7a","selected":"styles_selected__GzZv+"};